import React, { useEffect, useState, Fragment } from "react";
import styled from "styled-components";
import Search from "./Search";
import { fetchJson, post } from "../../../lib/Fetching";
import Button from "../../Button";
import Link from "../../Link";
import CategoryTestings from "./CategoryTestings";

const Container = styled.div`
  z-index: 10000;
  min-height: 300px;
  position: fixed;
  left: 58%;
  top: 50%;
  min-width: 1000px;
  transform: translate(-50%, -50%);
  box-shadow: 0 10px 13px rgba(0, 0, 0, 0.15) !important;
`;
const EditButton = styled.div`
  width: 100%;
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
  background-color: white;
  border-top: 1px solid #ddd;
  border-left: 1px solid #ddd;
  border-right: 1px solid #ddd;
  margin-bottom: 0px;
`;
const SearchContainer = styled.div`
  display: flex;
  width: 100%;
  min-height: 200px;
`;
const Item = styled.div.attrs({ className: "basic-panel with-shadow" })`
  flex-grow: 1;
  padding: 15px;
  width: 33%;
`;
const FinalItem = styled.div`
  flex-grow: 1;
  padding: 15px;
  width: 33%;
  overflow-y: auto;
  max-height: 200px;
  padding: 20px;
  padding-top: 5px;
  background-color: white;
`;

export default function CategoryView({ category_id }) {
  const [techniques, setTechniques] = useState([]);
  const [matrices, setMatrices] = useState([]);
  const [testNames, setTestNames] = useState([]);
  const [tests, setTests] = useState(null);
  const [showEditing, setShowEditing] = useState(false);

  const loadTests = () => {
    fetchJson("/testing/categories/" + category_id + "/category_testings.json").then(
      (json) => {
        console.log("tests", json);
        setTests(json);
      }
    );
  };

  useEffect(() => {
    loadTests();
  }, []);

  const submit = () => {
    post("/testing/categories/" + category_id + "/category_testings.json", {
      technique_ids: techniques.map((t) => t.id),
      matrix_ids: matrices.map((t) => t.id),
      test_name_ids: testNames.map((t) => t.id),
    }).then((json) => {
      loadTests();
      setShowEditing(false);
      if (json.status === "ok") {
        alert("The category was successfully updated.");
      }
    });
  };

  const valid = techniques.length > 0;

  if (tests === null) return null;

  return (
    <Fragment>
      <div>
        <Button
          icon="fa-edit"
          title="Add Testing to Category"
          onClick={() => setShowEditing(!showEditing)}
        />
        <br />
        <br />
        <CategoryTestings tests={tests} categoryId={category_id} reload={loadTests} />
      </div>
      {showEditing && (
        <Container>
          <EditButton>
            <Button
              disabled={!valid}
              icon="fa-plus"
              title="Add To Category"
              primary
              onClick={submit}
            />
            &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;
            <Button
              className="pull-right"
              icon="fa-times"
              title="Hide"
              onClick={() => setShowEditing(!showEditing)}
            />
          </EditButton>
          <SearchContainer
            style={{
              padding: 0,
              borderLeft: "1px solid #DDD",
              borderRight: "1px solid #DDD",
            }}
          >
            <FinalItem>
              <h4>
                Techniques
                {techniques.length > 0 && " - " + techniques.length}
                {techniques.length > 0 && (
                  <Link className="pull-right" onClick={() => setTechniques([])}>
                    Clear
                  </Link>
                )}
              </h4>
              {techniques.length > 0 && (
                <ul>
                  {techniques.map((t) => (
                    <li>{t.name}</li>
                  ))}
                </ul>
              )}
              {techniques.length == 0 && (
                <p>You must pick at-least one technique to add to this category.</p>
              )}
            </FinalItem>
            <FinalItem>
              <h4>
                Matrices
                {matrices.length > 0 && " - " + matrices.length}
                {matrices.length > 0 && (
                  <Link className="pull-right" onClick={() => setMatrices([])}>
                    Clear
                  </Link>
                )}
              </h4>
              {matrices.length > 0 && (
                <ul>
                  {matrices.map((t) => (
                    <li>{t.name}</li>
                  ))}
                </ul>
              )}
              {matrices.length == 0 && (
                <p>
                  Selecting one or more matrices is optional. Only add matrices if it is
                  necessary to exclude other ones for the purpose of this category.
                </p>
              )}
            </FinalItem>
            <FinalItem>
              <h4>
                Test Names
                {testNames.length > 0 && " - " + testNames.length}
                {testNames.length > 0 && (
                  <Link className="pull-right" onClick={() => setTestNames([])}>
                    Clear
                  </Link>
                )}
              </h4>
              {testNames.length > 0 && (
                <ul>
                  {testNames.map((t) => (
                    <li>{t.name}</li>
                  ))}
                </ul>
              )}
              {testNames.length == 0 && <p>Selecting one or more test names is optional.</p>}
            </FinalItem>
          </SearchContainer>
          <SearchContainer>
            <Item>
              <Search
                placeholder={"Search for Techniques..."}
                url={"/techniques.json"}
                onChange={setTechniques}
                values={techniques}
                paramsBuilder={(value) => ({
                  form: {
                    search: value,
                  },
                })}
              />
            </Item>
            <Item>
              <Search
                placeholder={"Search for Matrices..."}
                url={"/matrices.json"}
                onChange={setMatrices}
                values={matrices}
                paramsBuilder={(value) => ({
                  form: {
                    search: value,
                  },
                })}
              />
            </Item>
            <Item>
              <Search
                placeholder={"Search for Test Names..."}
                url={"/measurements.json"}
                onChange={setTestNames}
                values={testNames}
                paramsBuilder={(value) => ({
                  form: {
                    search: value,
                  },
                })}
              />
            </Item>
          </SearchContainer>
        </Container>
      )}
    </Fragment>
  );
}
